/* eslint-enable import/no-webpack-loader-syntax */
import OfficeEvents from './office_events'
import initPresentationMonitor from './presentation_monitor'

export default function init () {
  if (!window.Office) { return }

  return new Promise((resolve) => {
    window.Office.initialize = async (reason) => {
      // Bind to the MS Office context so that we can get events for everything
      // that happens in MS Office.
      console.log('creating office events')
      const reactor = new OfficeEvents(window.Office, reason)
      console.log('creating office model')
      const officeModel = reactor.model

      initPresentationMonitor(officeModel)
      console.log('Finished presentation monitor')

      resolve(officeModel)
    }
  })
}
